import { Controller } from "@hotwired/stimulus"

// Manages add/remove of signature rows in the TimesheetTemplate form,
// and toggles the visibility of the per-signature custom-value text input
// based on the selected prefill (shown only when prefill === "custom").
export default class extends Controller {
  static targets = ["list", "rowTemplate"]

  connect() {
    this.listTarget
      .querySelectorAll('select[data-action*="toggleCustom"]')
      .forEach((select) => this.applyCustomVisibility(select))
  }

  add(event) {
    event.preventDefault()
    const html = this.rowTemplateTarget.innerHTML.replaceAll("__SIG_INDEX__", `new_${Date.now()}`)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest('[data-timesheet-template-signatures-target="row"]')
    if (row) {
      row.remove()
      this.element.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  updateLabel(event) {
    const row = event.currentTarget.closest('[data-timesheet-template-signatures-target="row"]')
    const label = row?.querySelector("[data-signature-summary-label]")
    if (label) label.textContent = event.currentTarget.value || event.currentTarget.placeholder
  }

  toggleCustom(event) {
    this.applyCustomVisibility(event.currentTarget)
  }

  // "Wer unterschreibt" only means something for blocks signed in the app.
  toggleCapture(event) {
    const row = event.currentTarget.closest('[data-timesheet-template-signatures-target="row"]')
    if (!row) return
    const signerBlock = row.querySelector(
      '[data-timesheet-template-signatures-target="signerBlock"]',
    )
    if (!signerBlock) return
    signerBlock.classList.toggle("hidden", event.currentTarget.value !== "digital")
  }

  applyCustomVisibility(selectEl) {
    const targetKind = selectEl.dataset.target
    if (!targetKind) return
    const row = selectEl.closest('[data-timesheet-template-signatures-target="row"]')
    if (!row) return
    const customInput = row.querySelector(
      `[data-timesheet-template-signatures-target="${targetKind}Custom"]`,
    )
    if (!customInput) return
    if (selectEl.value === "custom") {
      customInput.classList.remove("hidden")
    } else {
      customInput.classList.add("hidden")
    }
  }
}
